import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import { useUI } from "../contexts/UIContext";

export default function AppLoader() {
  const { isLoading } = useUI();

  return (
    <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 9999 }} open={isLoading}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
